<template>
  <div class="login-container">
    <div class="login-box">
      <h2 class="login-title">管理员登录</h2>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">用户名</label>
          <input
            type="text"
            id="username"
            v-model="username"
            required
            class="form-control"
            :disabled="isLoading"
          />
          <div v-if="!username.value && submitted" class="validation-error">用户名不能为空</div>
        </div>
        <div class="form-group">
          <label for="password">密码</label>
          <input
            type="password"
            id="password"
            v-model="password"
            required
            class="form-control"
            :disabled="isLoading"
          />
          <div v-if="!password.value && submitted" class="validation-error">密码不能为空</div>
        </div>
        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
        <button type="submit" class="btn-login" :disabled="isLoading">
          <span v-if="isLoading">登录中...</span>
          <span v-else>登录</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminLogin'
}
</script>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { login } from '@/api/auth';

const username = ref('');
const password = ref('');
const errorMessage = ref('');
const isLoading = ref(false);
const router = useRouter();

const submitted = ref(false);

const handleLogin = async () => {
  submitted.value = true;
  errorMessage.value = '';

  // 表单验证
  if (!username.value || !password.value) {
    return;
  }

  isLoading.value = true;

  try {
    const response = await login({
      username: username.value,
      password: password.value
    });

    // 存储登录状态
    localStorage.setItem('adminToken', response.token);
    localStorage.setItem('adminUser', JSON.stringify(response.user));

    // 跳转到管理后台首页
    router.push('/admin/products');
  } catch (err) {
    errorMessage.value = err.response?.data?.error || '登录失败，请检查用户名和密码';
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped lang="scss">
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.login-box {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.login-title {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333;
}

.form-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #666;
}

.form-control {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.btn-login {
  width: 100%;
  padding: 0.8rem;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-login:hover {
  background-color: #096dd9;
}

.error-message {
  color: #ff4d4f;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border: 1px solid #ffccc7;
  background-color: #fff2f0;
  border-radius: 4px;
}

/* 移动端响应式适配 */
@media (max-width: 768px) {
  .login-container {
    padding: 20px;
  }
  
  .login-box {
    max-width: 100%;
    padding: 1.5rem;
    margin: 0 10px;
  }
  
  .login-title {
    font-size: 1.5rem;
    margin-bottom: 1.2rem;
  }
  
  .form-control {
    padding: 0.7rem;
    font-size: 16px; /* 防止iOS缩放 */
  }
  
  .btn-login {
    padding: 0.9rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .login-container {
    padding: 15px;
  }
  
  .login-box {
    padding: 1.2rem;
    margin: 0 5px;
  }
  
  .login-title {
    font-size: 1.3rem;
  }
  
  .form-control {
    padding: 0.6rem;
  }
  
  .btn-login {
    padding: 0.8rem;
  }
  
  .error-message {
    font-size: 0.9rem;
    padding: 0.4rem;
  }
}
</style>